import config from "@/config";
import type { ConfirmationResponse, ConfirmationResponseData } from "@/features/register/types";
import { fetchServer } from "@/features/utils/fetch";
import type { AddressCreate, AddressFullType, CityInfoType } from "../../types";
import { AddressConverters } from "../converters";

export class AddressApiClient {
  static async edit(
    address: AddressFullType,
    leUuid: string | null
  ): Promise<ConfirmationResponseData<AddressFullType>> {
    const response = await fetchServer(
      leUuid ? `/user/address/edit?contextLegalEntityUuid=${leUuid}` : "/user/address/edit",
      {
        method: "PUT",
        reloadOn401: false,
        mainRoot: false,
        body: address
      }
    );

    if (!response.ok) throw new Error();

    const res = await response.json();
    return res;
  }
  static async create(
    userUUID: string,
    address: AddressCreate,
    id: string | null
  ): Promise<ConfirmationResponse> {
    const response = await fetchServer(
      id ? `/user/address/create_new?contextLegalEntityUuid=${id}` : "/user/address/create_new",
      {
        method: "POST",
        reloadOn401: false,
        mainRoot: false,
        body: AddressConverters.Create_FullDTO(userUUID, address)
      }
    );

    if (!response.ok) throw new Error();

    const res = await response.json();
    return res.data || { existStatus: false };
  }

  static async getCityCode(city: string): Promise<CityInfoType[]> {
    const response = await fetch(
      `${config.URL_GOV_FR}communes?nom=${encodeURIComponent(
        city
      )}&fields=code,nom,codesPostaux,departement&boost=population`
    );
    if (!response.ok) throw new Error();

    const res = await response.json();
    return res;
  }
}
